/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { DataService } from 'app/shared/services/data.service';
import { ApiDependenciesService } from 'app/api/services/api-dependencies.service';
import { Injectable } from '@angular/core';
import { AuditEntry } from 'app/shared/models/audit.model';

@Injectable({providedIn: 'root'})
export class LogDataService extends DataService<any> {

  constructor(protected dependencies: ApiDependenciesService) {
    super(dependencies);
  }

  public async submitAudit(audit: AuditEntry): Promise<boolean> {

    let result = false;

    await this
      .setEndpoint('/audit/submit')
      .save(audit)
      .then(() => {
        result = true;
      })
  
      return Promise.resolve(result);
  }
}
